import { render, staticRenderFns } from "./IconClipboardSolid.vue?vue&type=template&id=7a122946"
import script from "./IconClipboardSolid.vue?vue&type=script&lang=js"
export * from "./IconClipboardSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports